import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  Badge,
  Button,
  Collapse,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedCollectionFilter,
  deleteSelectedCollectionFilter,
} from '../../actions/Collections';

import FiltersResetButton from './FiltersResetButton';

class FiltersCollectionUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapse: false,
    };

    this.toggle = this.toggle.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  getAvailableFilters() {
    const { availableFilters } = this.props;
    const options = [];
    availableFilters.forEach((filter) => {
      options.push({
        value: filter.key,
        label: filter.name,
      });
    });

    return options;
  }

  getSelectedFilters() {
    const {
      availableFilters,
      filters,
    } = this.props;
    const values = [];
    availableFilters.forEach((filter) => {
      if (window._.includes(filters, filter.key)) {
        values.push({
          value: filter.key,
          label: filter.name,
        });
      }
    });

    return values;
  }

  toggle() {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  }

  handleChangeFilter(values, action) {
    const {
      intl,
      filters,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;

    let newSelected = filters.slice(0);

    if (action.action === 'select-option') {
      const { option: value } = action;
      newSelected.push(value.value);
      addFilter({
        type: 'user_ids',
        key: value.value,
        label: value.label,
        title: intl.formatMessage({ defaultMessage: 'Owner' }),
      });
    }

    if (action.action === 'remove-value') {
      const { removedValue: value } = action;
      newSelected = newSelected.filter(s => (s !== value.value));
      removeFilter('user_ids', value.value);
    }

    if (action.action === 'clear') {
      this.getSelectedFilters().forEach((filter) => {
        newSelected = newSelected.filter(s => (s !== filter.value));
        removeFilter('user_ids', filter.value);
      });
    }

    handleChangeFilters({ user_ids: newSelected });
  }

  handleReset() {
    const action = {
      action: 'clear',

    };
    this.handleChangeFilter([], action);
  }

  render() {
    const { intl } = this.props;
    const { collapse } = this.state;
    const selected = this.getSelectedFilters();

    return (
      <div className="files-filter file-users-filter">
        <div className="filter-header">
          <Button onClick={this.toggle} className="filter-title">
            <i className={`fal fa-angle-${collapse ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'Owner' })}</span>
            {' '}
            {selected.length > 0 && (
              <Badge color="primary">
                {selected.length}
              </Badge>
            )}
          </Button>
          {selected.length > 0 && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={collapse}
          className="filter-body"
        >
          <div className="filter-form file-users-filter-form">
            <Select
              id="filterCollectionUsers"
              inputId="filterCollectionUsersInput"
              isClearable={false}
              isMulti
              options={this.getAvailableFilters()}
              onChange={this.handleChangeFilter}
              value={selected}
            />
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  filters: state.Collections.filters.user_ids,
  availableFilters: state.Collections.availableFilters.user_ids,
});

const mapDispatchToProps = dispatch => ({
  addFilter: (filter) => {
    dispatch(addSelectedCollectionFilter(filter));
  },
  removeFilter: (filterType, filterKey) => {
    dispatch(deleteSelectedCollectionFilter(filterType, filterKey));
  },
});

FiltersCollectionUsers.propTypes = {
  intl: PropTypes.object.isRequired,
  filters: PropTypes.array.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  availableFilters: PropTypes.array.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersCollectionUsers));
